module.exports = __webpack_public_path__ + "img/icon_ondivan.c54cf61a.png";